import "./Pagination.scss";
import { Input, Select } from "antd";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import React from "react";

const limitPageOptions = [
  { value: 10, label: "10" },
  { value: 20, label: "20" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

const PaginationTable = ({
  handlePaginations,
  limit,
  hasMore,
  handleLimit,
  page,
}) => {
  const Enter = 13;

  const onKeyDown = (e) => {
    if (e.keyCode === Enter) {
      // click vào phím enter
      const targetValue = +e.target?.value || 1; // Mặc định giá trị là 1 nếu không có giá trị hợp lệ
      handlePaginations(targetValue);
    }
  };

  const moveToNextPage = () => {
    if (page > 9999999) {
      return null;
    }
    handlePaginations(page + 1);
  };

  const moveToPreviousPage = () => {
    if (page < 2) {
      return null;
    }
    handlePaginations(page - 1);
  };

  const handleChangeLimit = (value) => {
    handleLimit(value);
  };

  const handleChange = (value) => {
    let newValue = Number(value.replace(/[^0-9]/g, ""));
    handlePaginations(newValue);
  };
  return (
    <div className="pagination_wrapper">
      {/* <Select
        style={{ width: 70 }}
        defaultValue={limit}
        onChange={handleChangeLimit}
        options={limitPageOptions}
      /> */}
      <div className="pagination">
        <div className="prev-item position-relative">
          <span
            onClick={() => moveToPreviousPage()}
            className={`bg_left ${page === 1 ? "disabled" : ""}`}
          >
            <FaChevronLeft />
          </span>
        </div>
        <div>
          <Input
            className="input_paging"
            value={page}
            onKeyDown={(e) => onKeyDown(e)}
            onChange={(e) => {
              handleChange(e.target.value);
            }}
          />
        </div>
        <div className="next-item position-relative">
          <span
            onClick={() => moveToNextPage()}
            className={`bg_right ${!hasMore ? "disabled" : ""}`}
          >
            <FaChevronRight />
          </span>
        </div>
      </div>
    </div>
  );
};

export default PaginationTable;
